import { Card, Link, Typography } from "@mui/joy";
import React from "react";
import "./WeddingStory.css";

function WeddingStory() {
  return (
    <Card className="card">
      <Typography level="h1" className="title">
        Our Story
      </Typography>

      <Typography level="body-lg" className="paragraph">
        David and Tala's journey began at The Ohio State University, where fate
        brought them together. Their first date took place in the vibrant Short
        North on October 8, 2017.
      </Typography>

      <Typography level="body-lg" className="paragraph">
        As they got to know each other, they uncovered a surprising coincidence:
        their high schools were just blocks apart. This revelation was only the
        beginning of countless shared experiences and remarkable similarities.
        Their first date felt less like a beginning and more like a reunion.
      </Typography>

      <Typography level="h2" className="quote">
        "When we first met, it was like I had known her for years."
      </Typography>
      <Typography level="body-md" className="quote-author">– David</Typography>

      <Typography level="h2" className="quote">
        "From the moment we started talking, everything just felt so natural."
      </Typography>
      <Typography level="body-md" className="quote-author">– Tala</Typography>

      <Typography level="body-lg" className="paragraph">
        Throughout their time at OSU, they became each other's{" "}
        <Link href="https://en.wikipedia.org/wiki/Rubber_duck_debugging">
          rubber duck
        </Link>
        — always ready to listen, support, and encourage.
      </Typography>

      <Typography level="body-lg" className="paragraph">
        Whether teaming up for hackathons across the country or running a 5K in
        the dark, they quickly became inseparable.
      </Typography>

      <Typography level="body-lg" className="paragraph">
        Cooking, traveling, gaming—their shared passions grew as they built a
        life together. 
      </Typography>
      <Typography level="body-lg" className="paragraph">
      Today, David and Tala call Seattle home, ready to embark
      on their greatest adventure yet.
      </Typography>
    </Card>
  );
}

export default WeddingStory;
